import { combineReducers } from 'redux';
import { hasIn } from 'lodash';

function byIdReducer(state = {}, action) {
  if (hasIn(action, ['normalizedData', 'entities', 'hiddenTags'])) {
    return action.normalizedData.entities.hiddenTags;
  } else {
    return state;
  }
}

function allIdsReducer(state = [], action) {
  if (hasIn(action, ['normalizedData', 'entities', 'hiddenTags'])) {
    if (action.normalizedData.result) {
      return action.normalizedData.result;
    } else {
      return [];
    }
  } else {
    return state;
  }
}

export default combineReducers({
  byId: byIdReducer,
  allIds: allIdsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/hiddenTagsReducer.js